(function () {
  const STORAGE_KEY = "fundraiser_campaign_code";
  const PROPERTY_KEY = "_fundraiser_campaign_code";

  /*
    Get current campaign
    Priority:
    1. URL parameter
    2. Current session campaign
  */
  function getCampaignCode() {
    const params = new URLSearchParams(window.location.search);
    const urlCampaign = params.get("fundraiser");

    if (urlCampaign) {
      sessionStorage.setItem(STORAGE_KEY, urlCampaign);
      return urlCampaign;
    }

    return sessionStorage.getItem(STORAGE_KEY);
  }

  /*
    Save campaign from collection page
  */
  function saveCollectionCampaign() {
    const campaign = document.body.dataset.collectionCampaign;

    if (campaign) {
      sessionStorage.setItem(STORAGE_KEY, campaign);
    }
  }

  /*
    Add campaign parameter to product links
    so product page does not lose campaign
  */
  function attachCampaignToProductLinks() {
    const campaign = document.body.dataset.collectionCampaign;

    if (!campaign) return;

    document.querySelectorAll('a[href*="/products/"]').forEach(link => {
      const url = new URL(link.href, window.location.origin);

      url.searchParams.set("fundraiser", campaign);
      link.href = url.toString();
    });
  }

  async function getCart() {
    const res = await fetch("/cart.js");
    return await res.json();
  }

  async function removeItems(items) {
    for (const item of items) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: item.key,
          quantity: 0
        })
      });
    }
  }

  /*
    Remove previous fundraiser products
  */
  async function cleanCart(currentCampaign) {
    const cart = await getCart();

    const remove = cart.items.filter(item => {
      const itemCampaign = item.properties && item.properties[PROPERTY_KEY];

      /*
        Different fundraiser
      */
      if (currentCampaign) {
        return itemCampaign && itemCampaign !== currentCampaign;
      }

      /*
        Normal product
      */
      return itemCampaign;
    });

    if (remove.length) {
      await removeItems(remove);
    }
  }

  /*
    Add property before Horizon submits cart
  */
  function injectProperty(form, campaign) {
    if (!campaign) return;

    let input = form.querySelector(`[name="properties[${PROPERTY_KEY}]"]`);

    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = `properties[${PROPERTY_KEY}]`;
      form.appendChild(input);
    }

    input.value = campaign;
  }
/*
  Save campaign on cart attribute
  This will be available after checkout
  and can be used by Shopify Flow to add order tags
*/
async function setCartAttribute(campaign) {
  await fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      attributes: {
        fundraiser_campaign_code: campaign
      }
    })
  });
}


/*
  Remove fundraiser attribute when switching to normal product
*/
async function clearCartAttribute() {
  await fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      attributes: {
        fundraiser_campaign_code: ""
      }
    })
  });
}
  function init() {
    document.addEventListener(
      "submit",
      async function (e) {
        const form = e.target;

        if (
          !form.closest("product-form") &&
          !form.matches('form[action*="/cart/add"]')
        ) {
          return;
        }

        const campaign = getCampaignCode();

        if (campaign) {
          await cleanCart(campaign);
          // Add line item property
          injectProperty(form, campaign);
          // Add cart attribute for Shopify Flow order tagging
          await setCartAttribute(campaign);
        } else {
          await cleanCart(null);
          // Remove old fundraiser attribute when normal product is added
          await clearCartAttribute();
        }
      },
      true
    );
  }

  document.addEventListener("DOMContentLoaded", function () {
    saveCollectionCampaign();
    attachCampaignToProductLinks();
    init();
  });
})();